// extracted by mini-css-extract-plugin
module.exports = {"writingMaterialForm":"style-module__writingMaterialForm___2pK-x","error":"style-module__error___SqS2p"};